import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  DICT_TYPE_REGISTRATION_ID_TYPE,
  DictService, FILE_TYPE_ANOTHER_MULTI,
  REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION,
  REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT,
  REGISTRATION_ID_TYPE_SENT
} from "../../../shared/services/dict.service";
import {from, Observable, of, ReplaySubject} from "rxjs";
import {Registration} from "../../../shared/interface/registration";
import {Dictionary} from "../../../shared/interface/dictionary";
import {RegistrationIdentifier} from "../../../shared/interface/registration-identifier";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {RegistrationService} from "../../../shared/services/registration.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {delay, filter, first, take, takeUntil, tap} from "rxjs/operators";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {Ofwca} from "../../../shared/interface/ofwca";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {IdentifierService} from "../../../shared/services/identifier.service";
import {RegistrationIdInlineForm} from "../registration-details-form/registration-details-form.component";
import {HttpErrorResponse} from "@angular/common/http";
import {Uuid} from "../../../shared/interface/response/uuid";

@Component({
  selector: 'app-registration-identifiers',
  templateUrl: './registration-identifiers.component.html',
  styleUrls: ['./registration-identifiers.component.scss']
})
export class RegistrationIdentifiersComponent implements OnInit {
  @Input() registration: Observable<Registration>;
  @Output() changed = new EventEmitter<any>();

  registrationForm: FormGroup;
  modifyActive = false;
  registrationObject: Registration;
  registrationIdTypes: { [key: string]: Dictionary } = {};
  registrationIdentifiers: { [key: string]: RegistrationIdentifier } = {};
  registrationIdForms: { [key: string]: RegistrationIdInlineForm } = {};

  activeIdentifierEdit: any;
  processingRequest = false;
  errors: any = {};
  userPermissionss: ReplaySubject<UserPermissions>;
  userPermissions: UserPermissions;
  selectedOfwca?: Ofwca;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private registrationService: RegistrationService,
    private dictService: DictService,
    private fb: FormBuilder,
    private ofwcaService: OfwcaService,
    private identifierService: IdentifierService,
    private cdr: ChangeDetectorRef
  ) {
    this.userPermissionss = auth.getUserPermissions();
    this.registrationForm = this.fb.group({});
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissions = userPermissions;
      });

  }
  ngOnInit(): void {

    this.registration
      .pipe(takeUntil(this.destroyed$))
      .subscribe((registration: Registration) => {
          this.registrationObject = registration;
        this.initialize(this.registrationObject);
        this.loadIdDict();
        // this.loadIds();
      });
  }

  loadIds(): void {
    this.registrationService.getRegistrationIds(this.registrationObject.uuid)
      .subscribe((response: ListResponse<RegistrationIdentifier>) => {
        response.items.forEach((identifier: RegistrationIdentifier) => {
          this.registrationIdentifiers[identifier.type.key] = identifier;
        });
      });
  }

  loadIdDict(): void {
    this.dictService.getDictSubject()
      .pipe(first())
      .subscribe((items: Dictionary[]) => {
        items.forEach((dict: Dictionary) => {
          if (
            dict.type === DICT_TYPE_REGISTRATION_ID_TYPE && this.registrationObject
            && this.registrationObject.insuranceCompany.registrationIdTypes.includes(dict.key)
          ) {
            this.registrationIdTypes[dict.key] = dict;
          }
        });

      });
  }

  copyMessage(val: string): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBar.open('Skopiowano do schowka', '', {duration: 2000});

  }
  editOne(val: any): void {
    this.activeIdentifierEdit = String(val);
    this.modifyActive = true;
  }

  parseValue(value: string, type: Dictionary): string | string[] {
    if (!value) {
      return '';
    }

    if (type.valueType === 'bool') {
      if (value.toLowerCase() === 'tak') {
        return 'Tak';
      } else {
        return 'Nie';
      }
    } else {
      return value.split(',');
    }
  }

  initialize(registration: Registration): void {
    of(registration)
      .pipe(
        delay(0),
        tap(() => {
          this.buildIdentifierForms();
          this.ofwcaService.get(registration.ofwca.uuid)
            .subscribe((ofwca: Ofwca) => {
              this.selectedOfwca = ofwca;
            });
        }),
        delay(0),
        tap(() => {
          this.initialized.next(true);
        })
      ).subscribe();
  }


  buildIdentifierForms(): void {
    this.dictService.getDictSubject()
      .pipe(
        first()
      )
      .subscribe((items: Dictionary[]) => {
        this.registrationService.getRegistrationIds(this.registrationObject.uuid)
          .pipe(first())
          .subscribe((response: ListResponse<RegistrationIdentifier>) => {
            response.items.forEach((identifier: RegistrationIdentifier) => {
              this.registrationIdentifiers[identifier.type.key] = identifier;
            });
            items.forEach((dict: Dictionary) => {
              if (
                dict.type === DICT_TYPE_REGISTRATION_ID_TYPE && this.registrationObject
                && this.registrationObject.insuranceCompany.registrationIdTypes.includes(dict.key)
                && (!dict.secured || (dict.secured && this.userPermissions.registration.id_import))
              ) {
                let exists = false;
                response.items.forEach((identifier: RegistrationIdentifier) => {
                  if (dict.key === identifier.type.key) {
                    this.registrationIdForms[dict.key] = {
                      identifierName: dict.name,
                      currentIdentifierId: identifier.uuid,
                      typeDict: dict,
                      formGroup: this.fb.group({
                        registration: this.fb.control(this.registrationObject.uuid),
                        type: this.fb.control(dict.id),
                        value: this.fb.control(this.parseValue(identifier.value, dict)),
                      })
                    };
                    exists = true;
                  }
                });

                if (!exists) {
                  this.registrationIdForms[dict.key] = {
                    identifierName: dict.name,
                    currentIdentifierId: null,
                    typeDict: dict,
                    formGroup: this.fb.group({
                      registration: this.fb.control(this.registrationObject.uuid),
                      type: this.fb.control(dict.id),
                      value: this.fb.control(''),
                    })
                  };
                }
              }
            });
          });
      });
  }

  getControl(group: FormGroup, name: string): FormControl {
    return group.get(name) as FormControl;
  }


  save(type: string): void {
    this.processingRequest = true;
    const forms = [];
    let filterforms = [];
    for (const [key, value] of Object.entries(this.registrationIdForms)) {
      forms.push(value);
    }

    if (forms.length === 0) {
      forms.push(null);
    }
    filterforms = forms.filter(item => item.typeDict.key === type);
    from(filterforms)
      .pipe(
        tap((inlineForm: RegistrationIdInlineForm) => {
          if (!inlineForm) {
            return;
          }

          const idValue = inlineForm.formGroup.get('value').value;
          this.identifierService.sendForm({
            registration: this.registrationObject.uuid,
            type: inlineForm.formGroup.get('type').value,
            value: Array.isArray(idValue) ? idValue : [idValue],
          }, inlineForm.currentIdentifierId)
            .subscribe((response: Uuid) => {
              if(response) {
                this.snackBar.open('Pomyślnie zaktualizowano identyfikator', '', {
                  duration: 2000,
                });
                this.processingRequest = false;
                this.modifyActive = false;
                this.changed.emit(true);
                this.activeIdentifierEdit = null;
              }
            }, (error: HttpErrorResponse) => {
              this.processingRequest = false;

              this.snackBar.open('Podczas aktualizacji identyfikatora wystąpił błąd', error.status.toString(), {
                duration: 2000,
              });

              if (error.status === 400) {
                this.errors = error.error.error.list;
              }
            });
        })
      ).subscribe();
  }




  cancel(): void {
    this.modifyActive = false;
    this.activeIdentifierEdit = null;
  }
   readonly REGISTRATION_ID_TYPE_SENT = REGISTRATION_ID_TYPE_SENT;
   readonly FILE_TYPE_ANOTHER_MULTI = FILE_TYPE_ANOTHER_MULTI;
   readonly REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT = REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT;
   readonly REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION = REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION;
  protected readonly Number = Number;
}
